/**
* LAZY LOAD IMG
* loading non-critical img (and background img) at the moment of need
*
* for img use:
*  - data-src=url
*  -
*  - src=data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII= *
*
*  - class => "notLazy" to not include that img in lazyLoading function
*
* for background img use:
*  - data-bg=url
*
* To exclude an entire DOM element (as well as all the children) apply the class "notLazy" to that element.
*
* recall jsLazyLoadImages() every time you add images asynchronously
*
* @external Debouncer.fn
* @see {@link ./frontend.util.js => debouncer}
*
* @external imagesloaded
* @see {@link https://imagesloaded.desandro.com/}
*
* @param {object} settings => [OPTIONAL] settings object
* @param {bool} settings0=> [OPTIONAL] add all img to lazyLoad
* @param {bool} settings1 => [OPTIONAL] add all bacgkroundImg to lazyLoad
* @param {bool} settings2 => [OPTIONAL] container
*
*/
const jsLazyLoadImages = (asyncImg = true, asyncBg = true, container = document) => {
    if (!asyncImg && !asyncBg)
        return false;
    let lazyImgs = [];
    let lazyImagesBG = [];
    let lazyImages = [];
    let active = false;
    const jsLazyLoad = () => {
        // Puts the contents of the querySelectorAll into the array.
        lazyImgs = asyncImg ? [].slice.call(container.querySelectorAll("[data-src]:not(.notLazy):not([js-done])")) : lazyImgs;
        lazyImagesBG = asyncBg ? [].slice.call(container.querySelectorAll("[data-bg]:not([js-done])")) : lazyImagesBG;
        // filter out images inside '.notLazy' containers
        const notLazyNodes = [...container.querySelectorAll('.notLazy:not(img)')];
        lazyImgs.forEach(img => {
            if (notLazyNodes.some(node => node.contains(img)))
                lazyImgs.splice(img);
        });
        //notLazyNodes
        lazyImages = lazyImgs.concat(lazyImagesBG);
        active = false;
        if (active === false) {
            active = true;
            lazyImages.forEach(lazyImage => {
                if ((lazyImage.getBoundingClientRect().top - window.innerHeight / 2 <= window.innerHeight &&
                    lazyImage.getBoundingClientRect().bottom + window.innerHeight / 2 >= 0) &&
                    getComputedStyle(lazyImage).display !== "none") {
                    setTimeout(() => {
                        if (lazyImage.getAttribute("data-bg")) {
                            resizeBg([lazyImage]);
                        }
                        else {
                            lazyImage.src = lazyImage.getAttribute("data-src");
                        }
                        lazyImage.setAttribute("js-done", "1");
                        lazyImages = lazyImages.filter(image => image !== lazyImage);
                        if (lazyImages.length === 0) {
                            document.removeEventListener("scroll", jsLazyLoad);
                        }
                    }, 300);
                }
            });
            active = false;
        }
    };
    //clear old events
    document.removeEventListener("scroll", jsLazyLoad);
    window.removeEventListener('resize', debouncer(() => {
        resizeBg();
    }, 150));
    window.removeEventListener('orientationchange', debouncer(() => {
        resizeBg();
    }, 150));
    jsLazyLoad();
    document.addEventListener("scroll", jsLazyLoad);
    window.addEventListener('resize', debouncer(() => {
        resizeBg();
    }, 150));
    window.addEventListener('orientationchange', debouncer(() => {
        resizeBg();
    }, 150));
};
const resizeBg = (lazyImage) => {
    const lazyImagesBG = lazyImage ? lazyImage : [].slice.call(document.querySelectorAll("[data-bg]"));
    lazyImagesBG.forEach(lazyImage => {
        let url = "";
        if (window.innerWidth < 1200) {
            if (window.innerWidth > 767) {
                url = "data-bg768";
            }
            else {
                url = "data-bg480";
            }
        }
        else {
            url = "data-bg";
        }
        const backgroundImage = lazyImage.getAttribute(url) || lazyImage.getAttribute("data-bg");
        lazyImage.style.backgroundImage = `url('${backgroundImage}')`;
    });
};
